import { render, staticRenderFns } from "./holderInfo.vue?vue&type=template&id=780a6d32&scoped=true"
import script from "./holderInfo.vue?vue&type=script&lang=js"
export * from "./holderInfo.vue?vue&type=script&lang=js"
import style0 from "./holderInfo.vue?vue&type=style&index=0&id=780a6d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a6d32",
  null
  
)

export default component.exports